import { useEffect } from "react";
import React from "react";
import { Routes, Route, Navigate, Router } from "react-router-dom";
import Banner from "./components/Banner";
import NavBar from "./components/NavBar"; 
import Footer from "./components/Footer"; 

// Pages
import Homepage from './components/pages/HomePage';
import AlumniDetails from "./components/pages/AlumniDetails";
import StudentDetails from "./components/pages/StudentDetails"; 
import CareerDb from "./components/pages/CareerDb";
import CareerDash from "./components/pages/CareerDash";
import RegistrationPage from "./components/pages/RegistrationPage"; 
import EditAlumni from "./components/pages/EditAlumni";
import EditStudent from "./components/pages/EditStudent"; 
import LoginPage from "./components/pages/LoginPage";
import Faculty from './components/pages/Faculty';
import StudentDash from "./components/pages/StudentDash";
import AlumniDash from "./components/pages/AlumniDash";
// import Media from "./components/pages/Media";
import MediaGallery from "./components/pages/MediaGallery";
// import AlumniCarousel from "./components/pages/alumnispot"; // Uncomment if needed

// Routes
import { AlumniRoute, StudentRoute } from "./routes/PrivateRoutes"; 

import "./App.css"; 
import NavBarBanner from "./components/NavBarBanner";

function App() {
  useEffect(() => {
    console.log("🌍 App Mounted! Checking LocalStorage...");
    console.log("🔹 User ID in LocalStorage:", localStorage.getItem("userId"));
    console.log("🔹 Token in LocalStorage:", localStorage.getItem("token"));
    console.log("🔹 Role in LocalStorage:", localStorage.getItem("role"));
  }, []);

  return (
    <div className="App">
      {/* <Banner />
      <NavBar /> */}
<NavBarBanner/>
      {/* Main content container with margin to avoid overlap */}
      <div className="main-content">
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/pages/alumni-details" element={<AlumniDetails />} />
          <Route path="/pages/student-details" element={<StudentDetails />} />
          <Route path="/pages/registration" element={<RegistrationPage />} />
          <Route path="/pages/loginpage" element={<LoginPage />} />
          <Route path="/pages/career-db" element={<CareerDb />} />
          <Route path="/pages/career-dashboard" element={<CareerDash />} />
          <Route path="/pages/faculty" element={<Faculty />} />
          <Route path="/pages/student-dashboard" element={<StudentDash />} />
          <Route path="/pages/alumni-container" element={<AlumniDash />} />
          {/* <Route path="/pages/media-page" element={<Media />} /> */}
          {/* <Route path="/pages/carousel-container" element={<AlumniCarousel />} /> */}
          <Route path="/pages/media-page" element={<MediaGallery />} />
          {/* Protected Routes */}
          <Route path="/profile/alumni" element={<AlumniRoute />}>
            <Route index element={<EditAlumni />} />
          </Route>
          <Route path="/profile/student" element={<StudentRoute />}>
            <Route index element={<EditStudent />} />
          </Route>

          {/* Catch-all route */}
          <Route path="*" element={<Navigate to="/pages/registration" />} />
        </Routes>
      </div>

      <Footer />
    </div>
  );
}

export default App;